export const getters = {
  getModalViewPaymentMethod: state => state.modalAtivoDeInvestimento,
  getPaymentMethods: state => state.paymentMethods,
  getPaymentMethod: state => state.paymentMethod
};

export default {};
